import { Component, OnInit, inject } from "@angular/core";
import { Subject } from "rxjs";
import { ROUTE_ANIMATIONS_ELEMENTS, selectorAuth } from "@app/core";
import { select, Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { takeUntil } from "rxjs/operators";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { ActivatedRoute } from "@angular/router";
import { Resource } from "@lagoshny/ngx-hateoas-client";

@Component({
  selector: "app-base-single-entity-page",
  template: ``
})
export class BaseSingleEntityPageComponent<
  T extends Resource
> implements OnInit {
  private route = inject(ActivatedRoute);
  protected store = inject<Store<any>>(Store);
  protected dialog = inject(MatDialog);

  public routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  id: number = -1;
  public isAdmin = false;
  public isLoading = true;
  public isError = false;
  public errorMessage: string = "";
  public newMode = false;
  public detachedMode = false;
  protected unsubscribe$: Subject<void> = new Subject<void>();

  constructor() {
    this.route.params.subscribe((params) => {
      this.id = params["id"];
      console.log(params["id"]);
      if (params["id"] === "add") {
        this.newMode = true;
      }
    });
  }

  ngOnInit() {
    this.subscribeToIsAdmin();
  }

  protected subscribeToIsAdmin() {
    this.store
      .pipe(select(selectorAuth))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((auth) => {
        this.isAdmin = auth.isAdmin;
      });
  }

  protected loadDataSource(source: RealTimeDataStore<T>): Promise<T | null> {
    return new Promise<T>((resolve) => {
      if (this.newMode) {
        this.isLoading = false;
        resolve(null);
        return;
      }
      source
        .loadSingle(this.id, this.detachedMode)
        .then((entity) => {
          resolve(entity);
          this.isLoading = false;
        })
        .catch((error) => {
          resolve(null);
          this.isLoading = false;
          this.isError = true;
          this.errorMessage = error.message;
        });
    });
  }

  protected retry(source: RealTimeDataStore<any>) {
    this.isLoading = true;
    this.isError = false;
    this.errorMessage = null;
    this.loadDataSource(source);
  }
}
